import React, { HTMLAttributes, ReactNode } from 'react';
import { CardWrapper } from '../CardWrapper';
import styles from './ContentCard.module.scss';
import cn from 'classnames';

export interface ContentCardProps
  extends Pick<HTMLAttributes<HTMLDivElement>, 'className' | 'style'> {
  title?: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
  image?: ReactNode;
}

export default function ContentCard(props: ContentCardProps) {
  const { title, description, footer, image, className, style } = props;
  return (
    <CardWrapper className={cn(styles.wrapper, className)} style={style}>
      <div className="row">
        {image && <div className="col-xs-4">{image}</div>}
        {(title || description) && (
          <div className={image ? 'col-xs-8' : 'col-xs-12'}>
            {title && <span>{title}</span>}
            {description && <span>{description}</span>}
          </div>
        )}
      </div>
      {footer && (
        <div className="row">
          <div className="col-xs-offset-4 col-xs-8">{footer}</div>
        </div>
      )}
    </CardWrapper>
  );
}
